import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthProvider"; // ⬅️ IMPORTANTE

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider> {/* ⬅️ ENVOLVÉ ACÁ */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
